import React from 'react';
import { TrendingUp } from 'lucide-react';
import ComingSoon from '../components/ComingSoon';

const QuoteChanges = () => {
  return (
    <ComingSoon
      featureName="Quote Changes"
      description="Track and manage changes to your construction quotes over time. Monitor cost fluctuations, compare revisions, and maintain a complete audit trail of all quote modifications throughout your project lifecycle."
      icon={TrendingUp}
    />
  );
};

export default QuoteChanges;
